export enum VehicleStatus {
	AVAILABLE = "AVAILABLE",
	DELIVERED = "DELIVERED",
	ONLINE_ORDERED = "ONLINE_ORDERED",
	ONLINE_RESERVED = "ONLINE_RESERVED",
	OPEN_CAMPAIGNS = "OPEN_CAMPAIGNS",
	REMOVED = "REMOVED",
	RESERVED = "RESERVED",
	SOLD = "SOLD",
	SOLD_LINK = "SOLD_LINK",
}
